import { DatePicker, Form, Input, Modal, Typography } from 'antd';
import { useEffect } from 'react';

export default function GeneratePayoutOverrideModal({
  open,
  setOpen,
  invoiceId,
  loading,
  onOk,
}) {
  const { Text } = Typography;
  const [form] = Form.useForm();
  const completedDate = Form.useWatch('completedDate', form);
  const notes = Form.useWatch('notes', form);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, invoiceId]);

  return (
    <Modal
      title="Generate payout with overrides"
      open={open}
      onCancel={() => setOpen(false)}
      onClose={() => setOpen(false)}
      okText="Generate Payout"
      confirmLoading={loading}
      okButtonProps={{
        disabled: !completedDate || !notes?.trim(),
      }}
      cancelButtonProps={{ disabled: loading }}
      maskClosable={!loading}
      onOk={() => form.submit()}
      centered
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <Text>
          A payout will be created in <Text strong>Payout Completed</Text> for
          invoice <Text strong>{invoiceId}</Text>.
        </Text>
        <Text style={{ fontSize: 12 }} italic>
          Note: This skips the usual payout eligibility checks. Provide the date
          the contributor was actually paid and why the override was needed.
        </Text>
      </div>
      <Form
        form={form}
        layout="vertical"
        style={{ margin: '16px 0 0' }}
        onFinish={(values) =>
          onOk(invoiceId, {
            // Sent as UTC midnight so the picked calendar date is not shifted
            // by the browser timezone.
            completedDate: values.completedDate.format(
              'YYYY-MM-DD[T]00:00:00[Z]',
            ),
            notes: values.notes.trim(),
          })
        }
      >
        <Form.Item
          name="completedDate"
          label="Completion date"
          rules={[
            { required: true, message: 'Please select a completion date' },
          ]}
        >
          <DatePicker style={{ width: '60%' }} disabled={loading} />
        </Form.Item>
        <Form.Item
          name="notes"
          label="Notes"
          rules={[
            {
              required: true,
              whitespace: true,
              message: 'Please enter notes for this override',
            },
          ]}
        >
          <Input.TextArea
            rows={4}
            maxLength={500}
            showCount
            disabled={loading}
            placeholder="Reason for generating this payout with overrides"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
